import React, { useContext, useRef, useState } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { MdFeedback } from "react-icons/md";
import { PiThumbsUpFill, PiThumbsDownFill } from "react-icons/pi";
import { submitFeedback } from "../../utils/apiCalls";
import { CountriesList } from "./countrieslist";
import { FormContext } from "../../pages/CMSRenderer/CMSRenderer";

const Pagereview = () => {
  const [modalType, setModalType] = useState(null); 
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    comment: "",
  });

  const [errors, setErrors] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(CountriesList[0]);
  const { currentLang } = useContext(FormContext);

  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    setDropdownOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim())
      newErrors.name =
        currentLang === "ar" ? "الاسم الكامل مطلوب" : "Full name is required";
    if (!formData.email.trim()) {
      newErrors.email =
        currentLang === "ar" ? "البريد الإلكتروني مطلوب" : "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email =
        currentLang === "ar"
          ? "تنسيق البريد الإلكتروني غير صالح"
          : "Invalid email format";
    }
    if (!formData.phoneNumber.trim())
      newErrors.phoneNumber =
        currentLang === "ar" ? "رقم الهاتف مطلوب" : "Phone number is required";
    // if (!formData.comment.trim()) newErrors.comment = currentLang === "ar" ? "التعليق مطلوب" : "Comment is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    
    const currentPageUrl = window.location.href;
    
    const fullPhoneNumber = `${selectedCountry.code}${formData.phoneNumber}`;
    
    submitFeedback({
      wasHelpful: false,
      ...formData,
      phoneNumber: fullPhoneNumber,
      pageUrl: currentPageUrl,
    }).then((res) => {
      if (res.code === 200) {
        setLoading(false);
        setModalType("success");
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          comment: "",
        });
      } else {
        alert(res.errorMsg);
        setLoading(false);
      }
    });

    console.log("✅ Submitting:", formData);
    console.log("✅ Submitting", formData);
  };

  const handleThumbUp = () => {
    setLoading(true);
    
    const currentPageUrl = window.location.href;
    
    submitFeedback({
      wasHelpful: true,
      pageUrl: currentPageUrl,
    }).then((res) => {
      if (res.code === 200) {
        setLoading(false);
        setModalType("success");
      } else {
        setLoading(false);
      }
    });
  };
  const handleThumbDown = () => setModalType("feedback");

  const handleClose = () => setModalType(null);

  return (
    <>
      {/* Page Review Bar */}
      <div className="md:w-[90vw] m-auto px-[20px]">
        <div className="border rounded-xl md:p-6 p-4 my-7 gap-2 flex justify-center items-center flex-wrap">
          <p className="font-medium md:my-3 my-1 pe-3 text-center">
            {currentLang === "ar"
              ? "هل وجدت محتوى هذه الصفحة مفيدًا؟"
              : "Did you find the content of this page helpful?"}
          </p>
          <div className="flex justify-center gap-3">
            <button
              type="button"
              disabled={loading}
              className="group bg-[var(--dda-neutral-94)] rounded p-2 size-[38px]"
              onClick={handleThumbUp}
            >
              <span className="hidden">
                {currentLang === "ar" ? "نعم" : "Yes"}
              </span>
              <PiThumbsUpFill className="text-2xl text-primary group-hover:text-[#005760] transition-all group-hover:scale-105" />
            </button>
            <button
              disabled={loading}
              type="button"
              className="group bg-[var(--dda-neutral-94)] rounded p-2 size-[38px] scale-x-[-1]"
              onClick={handleThumbDown}
            >
              <span className="hidden">{currentLang === "ar" ? "لا" : "No"}</span>
              <PiThumbsDownFill className="text-2xl text-primary group-hover:text-[#005760] transition-all group-hover:scale-105" />
            </button>
          </div>
        </div>
      </div>
      {/* Feedback Modal */}
      {modalType === "feedback" && (
        <div className="fixed top-0 left-0 w-full h-full bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white w-full max-w-3xl rounded-xl p-6 m-4 shadow-lg">
            <div className="flex justify-between items-start">
              <h6 className=" flex items-center gap-2">
                <span>
                  <MdFeedback className="text-primary text-2xl" />
                </span>{" "}
                {currentLang === "ar"
                  ? "شكرا لتعليقاتك!"
                  : "Thank you for your feedback!"}
              </h6>
              <button onClick={handleClose}>
                <IoIosCloseCircleOutline className="text-2xl" />
              </button>
            </div>
            <p className="text-onSurfaceVariant label mt-2">
              {currentLang === "ar"
                ? "نحن نقدر ملاحظاتك على موقعنا الإلكتروني، يرجى إعلامنا بكيفية تحسين موقعنا الإلكتروني وخدمتك بشكل أفضل من خلال إضافة تعليقاتك مع تفاصيل الاتصال الخاصة بك أدناه."
                : "Your feedback on our website is highly appreciated, kindly inform us how can we improve our website and serve you better by adding your comments with your contact details below."}
            </p>
            <form className="space-y-3 mt-4" onSubmit={handleSubmit}>
              {/* Full Name */}
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder={
                    currentLang === "ar" ? "الاسم الكامل" : "Full Name"
                  }
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 Regular text-[#5E5E62] body focus-within:outline-none border-color-[#E4E2E6] border rounded-lg min-h-[50px] py-2"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm">{errors.name}</p>
                )}
              </div>

              {/* Email + Phone */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder={
                      currentLang === "ar" ? "بريد إلكتروني" : "Email"
                    }
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full Regular text-[#5E5E62] body focus-within:outline-none border-color-[#E4E2E6] border rounded-lg min-h-[50px] px-4 py-2"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </div>

                {/* <div>
                  <input
                    type="tel"
                    name="phoneNumber"
                    placeholder="+971 00 000 0000"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    className="w-full Regular text-[#5E5E62] body focus-within:outline-none border-color-[#E4E2E6] border rounded-lg min-h-[50px] px-4 py-2"
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div> */}
                <div>
                  <div className="dda-input-field-group dda-phone-field">
                    {/* Dropdown */}
                    <div
                      className="dda-input-dropdown-btn"
                      style={{ minWidth: "unset" }}
                    >
                      <button
                        type="button"
                        className="dda-dropdown-select"
                        onClick={() => setDropdownOpen((prev) => !prev)}
                      >
                        <img src={selectedCountry.flag} alt="" width="20" />
                        <span>{selectedCountry.code}</span>
                        <i className="material-icons">keyboard_arrow_down</i>
                      </button>

                      {dropdownOpen && (
                        <div className="dda-input-dropdown-list">
                          {CountriesList.map((country) => (
                            <button
                              key={country.code}
                              type="button"
                              className="country-select dda-input-dropdown-item"
                              onClick={() => handleSelectCountry(country)}
                            >
                              <img src={country.flag} alt="" width="20" />
                              {country.code}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Input */}
                    <input
                      type="tel"
                      name="phoneNumber"
                      placeholder={"000 000 000"}
                      maxLength={15}
                      disabled={false}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="dda-field-group-input"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div>
              </div>

              {/* Comments */}
              <div>
                <textarea
                  name="comment"
                  placeholder={currentLang === "ar" ? "تعليقات" : "Comments"}
                  maxLength="200"
                  rows="5"
                  value={formData.comment}
                  onChange={handleChange}
                  className="w-full Regular text-[#5E5E62] body focus-within:outline-none border-color-[#E4E2E6] border rounded-lg px-4 py-2"
                ></textarea>
                <div className="flex justify-between text-sm text-gray-500">
                  {errors.comment && (
                    <p className="text-red-500">{errors.comment}</p>
                  )}
                  {/* <span>{formData.comment.length} / 200</span> */}
                </div>
              </div>

              {/* Buttons */}
              <div className="flex gap-4">
                <button
                  type="button"
                  className="w-1/2 bg-white border-color-[#E4E2E6] h-[40px] border rounded-lg p-2"
                  onClick={() =>
                    handleClose() &&
                    setFormData({
                      name: "",
                      email: "",
                      phoneNumber: "",
                      comment: "",
                    })
                  }
                >
                  {currentLang === "ar" ? "يلغي" : "Cancel"}
                </button>
                <button
                  disabled={loading}
                  type="submit"
                  className="w-1/2 bg-primary text-white border rounded-lg h-[40px] p-2"
                >
                  {currentLang === "ar" ? "يُقدِّم" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {modalType === "success" && (
        <div className="fixed top-0 right-0 w-full h-full bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white w-full max-w-md rounded-xl p-6 m-4 shadow-lg text-center">
            <div className="flex justify-end">
              <button onClick={handleClose}>
                <IoIosCloseCircleOutline className="text-2xl" />
              </button>
            </div>
            <img
              src="/attachments/medialib/54008598-1ba2-4e45-b082-5394429e666f-1759140690289-684313320-ThankYou.svg"
              alt="Thank you illustration"
              className="w-32 mx-auto my-4"
            />
            <h4 className="">
              {currentLang === "ar" ? "شكرًا لك!" : "Thank You!"} <br />
              {currentLang === "ar"
                ? "نحن نقدر ملاحظاتك."
                : "We appreciate your feedback."}
            </h4>
          </div>
        </div>
      )}
    </>
  );
};

export default Pagereview;